import toast from 'react-hot-toast';

interface CustomToastProps {
  type: 'success' | 'error' | 'loading';
  message?: any;
  id?: string;
  duration?: number;
}

//@ts-ignore
const CustomToast = ({ type, message, id, duration = 2000 }: CustomToastProps) => {
  const toastStyle = {
    borderRadius: '10px',
    background: '#333',
    color: '#fff',
  };
  const options = { style: toastStyle, duration: duration, ...(id && { id }) };
  switch (type) {
    case 'success':
      return toast.success(message);
    case 'error':
      return toast.error(message, options);
    case 'loading':
      return toast.loading(message, options);
    default:
      return toast.success(message, options);
  }
};

export default CustomToast;
